import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { ExportDataService } from '../../../shared/services/export-data.service';
import { MaintenanceService } from '../../services/maintenanceService';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-decom-lob',
    templateUrl: './decom-lob.component.html',
    styleUrl: './decom-lob.component.scss',
    standalone: false
})
export class DecomLobComponent implements OnInit {

  @Input() DecomLobEditAccess: boolean;
  @Input() DecomLobViewAccess: boolean;

  expandAll: string = 'false';
  exportToExcel: number = 1;
  allRowsExpanded = false;
  postData;
  isUserAdmin: string = 'false';
  selectedCapability;
  dataSourceDetails: MatTableDataSource<any>;
  olddatasource: any;
  rawDataSet: any;
  TABLE_COLUMNS: any = [
    {
      key: 'MBO_Segment_ID',
      label: 'MBO Segment ID',
      filter: true,
      width: '15% !important',
      padding: '5px 5px 5px 24px !important',
      sortable: true
    },
    {
      key: 'MBO_Segment',
      label: 'MBO Segment',
      filter: true,
      width: '15% !important',
      padding: '5px 5px 5px 24px !important',
      sortable: true
    },
    
    {
      key: 'Leader_Name',
      labelKey: 'Leader_Name',
      label: 'MBO Owner',
      width: '30% !important',
      edit: true,
      search: '',
      searchValue: '',
      filter: true,
      padding: '5px 5px 5px 0px !important',
      sortable: true
    },
    
    {
      key: 'Decom_Target_Year',
      label: 'MBO Year',
      width: '15% !important',
      sortable: true
    },
    {
      key: 'Decom_Target',
      label: 'MBO',
      width: '15% !important',
      align: 'center !important',
      currency: true,
      sortable: true
    },
    {
      key: 'Actions',
      label: 'Actions',
      width: '10% !important',
      align: 'center !important',
      padding: '5px 5px 5px 0px !important'
    }
  ];

  expanded_columns: any = [
    {
      key: 'DecomLobID',
      labelKey: 'DecomLobID',
      label: 'Business Segment ID',
      width: '15% !important',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ required: true }],
      padding: '5px 5px 5px 24px !important'
    },
    {
      key: 'DecomLobName',
      labelKey: 'DecomLobName',
      label: 'Business Segment',
      width: '15% !important',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ required: true }],
      padding: '5px 5px 5px 24px !important'
    },
    {
      key: 'Actions',
      label: '',
      width: '2% !important',
      align: 'center !important',
    }
  ];

  editModelView: boolean = environment.isAdminRole;
  FILTERS: any = [];

  DATA_SCHEMA = {
    MasterSegment: 'select',
    CIOLOB: 'select',
    SubLineofBusiness: 'select',
    DecomLobName: 'autocomplete',
    isEdit: 'isEdit'
  };
  initiativeList: any = [];
  FILTER_OPTIONS: any = {};
  OriginalFiltersList: any = {};
  TABLE_CONFIG: any = {
    expandable: true,
    pageSize: 10,
    pageIndex: 0,
    totalItems: 10,
    selection: false,
    edit: false,
    LOBLeaderAdmin: false,
    DecomLobEditAccess: false,
    serverSidePagination: false,
    dependentFilters: {
      MasterSegment: ['CIOLOB', 'SubLineofBusiness']
    }
  };

  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };

  showLoader: boolean = true;
  partialLoader: boolean = false;
  searchField: any;
  deleteRecords: any;
  userAccessData: any;
  selectedOption: any = 'decom_lob';
  lobChecked = true;
  orgChecked = false;
  @ViewChild('modalAddLob', { static: false }) modalAddLob;
  @ViewChild('modalEditSubLob', { static: false }) modalEditSubLob;
  @ViewChild('modalEditLob', { static: false }) modalEditLob;
  EditColumnDataSubLob: any;
  EditColumnDataLob: any;
  isNewClicked: boolean = false;
  isSubLobEditClicked: boolean = false;
  isLobEditClicked: boolean = false;
  @ViewChild('deleteModel', { static: false }) deleteModel;
  isDeleteClicked: boolean = false;
  deleteSelectedSubLob: any;
  lobList: any;
  segmentList: { SegID: any; MasterSegment: any }[];
  sublobList: void;
  @ViewChild('bulkModel', { static: false }) bulkModel;
  isBulkClicked: boolean = false;
  dataSourceFull: any;
  dataPersistObj: MatTableDataSource<any>;
  lobLoader: boolean = false;
  accessDataSet = false;
  lobDataSet = false;
  sort: any;

  constructor(
    private router: Router,
    public maintenanceService: MaintenanceService,
    public exportService: ExportDataService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.deleteRecords = [];
    this.handleAppicationload();
  }
  collapseAllFunc(data) {
    if (data == true) {
      this.allRowsExpanded = true;
    } else {
      this.allRowsExpanded = false;
    }
  }
  expandAllFunc() {
    if (this.expandAll == 'true' || this.allRowsExpanded == true) {
      if (this.expandAll == 'false') this.expandAll = 'false1';
      else this.expandAll = 'false';
      this.allRowsExpanded = false;
    } else {
      this.expandAll = 'true';
      this.allRowsExpanded = true;
    }
  }

  handleAppicationload = async () => {
    const postparams: any = {};
    this.postData = postparams;
    this.selectedCapability = this.postData[this.postData['level']];
    this.showLoader = true;
    try {
      this.TABLE_CONFIG['DecomLobEditAccess'] = this.DecomLobEditAccess;
        this.getLobMappingDetails();
      if (this.TABLE_CONFIG['DecomLobEditAccess'] == 'true') {
        this.TABLE_CONFIG['edit'] = true;
        this.TABLE_CONFIG['selection'] = false;
      }
      this.accessDataSet = this.DecomLobViewAccess;
      this.showLoader = this.lobDataSet == true ? false : true;
    } catch (error) {
      console.error(error);
      this.accessDataSet = this.DecomLobViewAccess;
      this.showLoader = this.lobDataSet == true ? false : true;
    }
  };

  searchClear() {
    this.searchField = '';
  }

  exportToCsv() {
    const finalExport = [];
    this.dataSourceDetails.data.forEach(element => {
      const exportJSON: any = {};
      exportJSON['MBO Segment ID'] = element.MBO_Segment_ID;
      exportJSON['MBO Segment'] = element.MBO_Segment;
      exportJSON['MBO Owner MSID'] = element.Leader_Msid;
      exportJSON['MBO Owner'] = element.Leader_Name;
      exportJSON['MBO Target Year'] = element.Decom_Target_Year;
      exportJSON['MBO Target'] = element.Decom_Target;
      element.lob.forEach(sub => {
        exportJSON['Business Segment ID'] = sub.DecomLobID ? sub.DecomLobID : '';
        exportJSON['Business Segment'] = sub.DecomLobName ? sub.DecomLobName : '';
        finalExport.push(exportJSON);
      })
    })
    const fileName = 'Decom LOB';
    this.exportService.exportToExcel(fileName, [finalExport]);
    //this.exportToExcel = this.exportToExcel + 1;
  }

  getLobMappingDetails() {
    const filter = this.getFilters();
    this.deleteRecords = '';
    this.showLoader = true;
    this.searchField = '';
    this.TABLE_CONFIG['TABLE_CLASS'] = 'lob-maintenance-tble-container';
    this.TABLE_CONFIG['FILTER_OPTIONS'] = JSON.parse(JSON.stringify(this.FILTER_OPTIONS));
    this.maintenanceService.getDecomLobAccessDetails().subscribe(
      (results: any) => {
        if (results) {
          const dataset = results.map((ele, index) => {
            ele.lob.sort((a, b) => (a.SubLineofBusiness < b.SubLineofBusiness ? -1 : 1));
            ele.lob.forEach(i => {
              i['DecomLobID'] = i.DecomLobID;
              i['DecomLobName'] = i.DecomLobName;
              i['parent'] = {
                MBO_Segment: ele.MBO_Segment,
                MBO_Segment_ID: ele.MBO_Segment_ID,
                Leader_Msid: ele.Leader_Msid,
                Leader_Name: ele.Leader_Name,
                Decom_Target_Year: ele.Decom_Target_Year,
                Decom_Target: ele.Decom_Target,
              };
            });
            ele['id'] = index;
            const dataItem = {
              ...ele,
              childDataSource: new MatTableDataSource(ele.lob)
            };
            return dataItem;
          });
          this.olddatasource = dataset;
          this.dataSourceDetails = new MatTableDataSource(dataset);
          this.dataPersistObj = this.dataSourceDetails;
          this.TABLE_CONFIG.totalItems = results.data && results.data.length ? results.data[0].ROW_COUNT : 0;
          this.lobDataSet = true;
          this.showLoader = this.lobDataSet == true ? false : true;
          if (filter.filters.length == 0) {
            this.dataSourceFull = results;
          }
        }
      },
      error => {
        console.error(error);
        this.lobDataSet = true;
        this.showLoader = this.accessDataSet == true ? false : true;
        this.dataSourceDetails = new MatTableDataSource([]);
        this.TABLE_CONFIG.totalItems = 0;
      }
    );
  }

  getFilters() {
    const params: any = {};
    if (this.FILTERS) {
      params['filters'] = this.prepareFilters();
    }

    return params;
  }

  prepareFilters() {
    const filters = [];
    if (this.FILTERS && this.FILTERS.length) {
      this.FILTERS.forEach(element => {
        if (element.key && element.searchValue.length) filters.push({ name: element.key, values: element.searchValue });
      });
    }
    return filters;
  }

  /**
   *
   * @param event
   */
  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
      this.getLobMappingDetails();
    }
  }

  searchEvent(event) {
    if (event) {
      if (event.type == 'apply') {
        this.FILTERS.push(event.column);
      } else {
        this.FILTERS = this.FILTERS.filter(ele => ele.key != event.column.key);
      }
      this.TABLE_CONFIG['pageSize'] = 10;
      this.TABLE_CONFIG['pageIndex'] = 0;
      this.getLobMappingDetails();
    }
  }

  navigateHomePage() {
    this.router.navigate([{ outlets: { primary: 'landing-page' } }]);
  }

  searchDataSet(event) {
    this.olddatasource.forEach(element => {
      element.childDataSource = new MatTableDataSource(element['lob']);

      element.childDataSource.filterPredicate = function(data, filter: string): boolean {
        return (
          (data.DecomLobID || '').toLowerCase().includes(filter) ||
          (data.DecomLobName || '').toLowerCase().includes(filter) ||
          (data.Leader_Name || '').toLowerCase().includes(filter)
        );
      };
    });

    let filterValue = event ? (event.target as HTMLInputElement).value : '';
    filterValue = filterValue.trim().toLowerCase();

    this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
    this.dataSourceDetails.filterPredicate = function(data, filter: string): boolean {
      return (
        data.MBO_Segment_ID?.toLowerCase().includes(filter.toLowerCase()) ||
        data.MBO_Segment?.toLowerCase().includes(filter.toLowerCase()) ||
        data.Leader_Name?.toLowerCase().includes(filter.toLowerCase())
      );
    };
    this.dataSourceDetails.filter = filterValue;
    const lobFilteredData = this.dataSourceDetails.filteredData;
    this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
    this.dataSourceDetails.filterPredicate = function(data, filter: string): boolean {
      return (
        data.MBO_Segment_ID?.toLowerCase().includes(filter.toLowerCase()) ||
        data.MBO_Segment?.toLowerCase().includes(filter.toLowerCase()) ||
        data.Leader_Name?.toLowerCase().includes(filter.toLowerCase())
      );
    };

    const subLobFilteredData = [];

    if (lobFilteredData.length) {
      // lobFilteredData.forEach(item => {
      this.dataSourceDetails.data.forEach((element: any) => {
        const inLob =
          lobFilteredData.find(function(el) {
            return el.id == element.id;
          }) !== undefined;
        if (inLob) {
          subLobFilteredData.push(element);
        } else {
          element.childDataSource.filter = filterValue;
          if (element.childDataSource.filteredData.length) {
            // element.childDataSource = new MatTableDataSource(element.childDataSource.filteredData);
            subLobFilteredData.push(element);
          }
        }
      });
      // });
    } else {
      this.dataSourceDetails.data.forEach(element => {
        element.childDataSource.filter = filterValue;
        if (element.childDataSource.filteredData.length) {
          // element.childDataSource = new MatTableDataSource(element.childDataSource.filteredData);
          subLobFilteredData.push(element);
        }
      });
    }

    if (subLobFilteredData.length) {
      this.dataSourceDetails = new MatTableDataSource(subLobFilteredData);
    } else {
      this.dataSourceDetails.filter = filterValue;
    }
    this.expandAllFunc();
  }

  checkBoxEvent(event) {
    let deleteRec = [];
    if (event.data && event.data.length) {
      deleteRec = event.data.map(ele => {
        const obj: any = {
          LobID: ele['LobID'],
          SubLobID: ele['SubLobID']
        };
        return obj;
      });
    }
    this.deleteRecords = deleteRec;
  }

  // selectionTypeChange(event) {
  //   console.log('event', event);
  //   this.selectedOption = event.value;
  // }

  showInfo() {
    if (this.selectedOption === 'lob') {
      window.open(environment.docUrl + 'user-guide/lob-maintenance/');
    } else if (this.selectedOption === 'org') {
      window.open(environment.docUrl + 'user-guide/organization-maintenance/');
    } else if (this.selectedOption === 'decom_lob') {
      window.open(environment.docUrl + 'user-guide/overview/');
    } else if (this.selectedOption === 'enterprise_initiatives') {
      window.open(environment.docUrl + 'user-guide/overview/');
    }
  }

  refreshDecomDetailsTable() {
    console.log('refreshDecomDetailsTable called');
    this.handleAppicationload();
  }
}
